import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCol,
  IonDatetime,
  IonGrid,
  IonInput,
  IonItem,
  IonLabel,
  IonRow
} from '@ionic/react'
import React, { CSSProperties } from 'react'
import { ProfileContract } from '../../store/auth'

interface Props {
  contract: ProfileContract
}

const Contract: React.FC<Props> = props => {
  const contract = props.contract

  let status: CSSProperties = {
    background: 'orange',
    padding: 6,
    textAlign: 'center',
    textTransform: 'uppercase',
    letterSpacing: 4,
    color: 'white',
    fontWeight: 'bold',
  }

  switch (props.contract.status.toLowerCase()) {
    case 'polizziert':
      status = {
        ...status,
        background: 'green',
        color: 'white',
      }
      break

    case 'storno':
      status = {
        ...status,
        background: 'red',
        color: 'white',
      }
      break
  }


  return (
    <IonCard
      color={'light'}
      style={{
        marginBottom: 25,
      }}
    >
      {contract.polizzennummer && (
        <IonCardHeader>
          <IonCardTitle>{contract.polizzennummer}</IonCardTitle>
        </IonCardHeader>
      )}
      <div style={status}>
        {contract.status}
      </div>

      <div style={{
        background: 'rgba(0,0,0,0.6)',
        position: 'absolute',
        top: 10,
        zIndex: 10,
        right: -33,
        transform: 'rotate(45deg)',
        width: 100,
        padding: 4,
        letterSpacing: 2,
        textAlign: 'center',
        fontWeight: 'bold',
        color: '#EEE',
        boxShadow: '2px 2px rgba(0,0,0,0.1)',
      }}>
        {contract.contract_type}
      </div>

      <IonGrid>
        <IonRow>
          <IonCol>
            <IonItem>
              <IonLabel position="floating">Vertragsbegin</IonLabel>
              <IonDatetime value={contract.vertrags_beginn} displayFormat={'YYYY-MM-DD'} readonly/>
            </IonItem>
          </IonCol>
          <IonCol>
            <IonItem>
              <IonLabel position="floating">Vertragsende</IonLabel>
              <IonDatetime value={contract.end_date} displayFormat={'YYYY-MM-DD'} readonly/>
            </IonItem>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol>
            <IonItem>
              <IonLabel position="floating">{contract.pay_period}</IonLabel>
              <IonInput value={contract.amount_period+'€'} readonly/>
            </IonItem>
          </IonCol>
        </IonRow>
      </IonGrid>

      <div
        style={{
          background: '#DDD',
          padding: 6,
          textAlign: 'center',
          color: '#444',
        }}
      >
        {contract.ins_company}
      </div>
    </IonCard>
  )
}

export default Contract
